module.exports = __webpack_public_path__ + "7dc4237d83fc0d7b91cfd01e38ccb5.png";